export const capitalTranslations = {
  en: {
    "seo.capital.title": "Capital Raising — Asia-Pacific Investor Introductions | Peter Dingle",
    "seo.capital.description": "Direct, curated access to aligned investors across HK, Singapore, SE Asia, Australia and NZ. A quality-over-volume fundraising process with David Thomas.",

    "capital.hero.eyebrow": "Stage 2 · Capital Raising · Asia-Pacific",
    "capital.hero.title": "Get in front of the right Asia-Pacific investors. Without the noise.",
    "capital.hero.body": "For founders ready to raise across Hong Kong, Singapore, SE Asia, Australia and New Zealand, this is direct access to investors through people who already know them, not a list and a pitch deck blast.",
    "capital.hero.tag1": "Curated investor introductions",
    "capital.hero.tag2": "Quality over volume",
    "capital.hero.tag3": "Success-aligned commercials",
    "capital.hero.byline": "Peter Dingle (NZ) · In partnership with David Thomas (HK / Australia)",

    "capital.who.eyebrow": "Who This Is For",
    "capital.who.title": "Founders ready to raise, not founders still figuring it out.",
    "capital.who.item1": "Post-revenue or post-pilot, raising $1M – $10M.",
    "capital.who.item2": "NZ, AU or APAC-headquartered, with a credible reason to attract Asia-Pacific capital.",
    "capital.who.item3": "Have completed Stage 1 (Founder Readiness) or arrive with equivalent investor-ready clarity.",
    "capital.who.item4": "Want fewer, better investor conversations, not a wider funnel.",

    "capital.why.eyebrow": "Why Work With Us",
    "capital.why.title": "Two operators. Real relationships. No broker theatre.",
    "capital.why.item1.name": "Peter Dingle",
    "capital.why.item1.rest": " — two decades scaling businesses across 18 Asia-Pacific markets. Ex-Intel (multi-100M+ product launches), ex-HSBC Asset Management (Head of Ecosystems & VC, Hong Kong), co-founder of accelerators that have raised USD$50M+ for 75+ startups.",
    "capital.why.item2.name": "David Thomas",
    "capital.why.item2.rest": " — 25+ years operating between Asia-Pacific capital and Western businesses. Direct relationships with VCs, family offices and strategic investors across the region.",
    "capital.why.item3": "Every introduction goes through a name you can place. We do not blast decks.",
    "capital.why.item4": "Commercials aligned to outcomes, not activity.",

    "capital.peter.alt": "Peter Dingle, founder advisor and CEO mentor",
    "capital.peter.name": "Peter Dingle",
    "capital.peter.role": "Founder Advisor · CEO Mentor · Based New Zealand",
    "capital.peter.linkedin": "LinkedIn",
    "capital.peter.website": "petermdingle.com",
    "capital.peter.eyebrow": "About Peter",
    "capital.peter.title": "Two decades operating at the front of Asia-Pacific growth.",
    "capital.peter.intro": "Peter brings the founder-side discipline and commercial track record that anchors Stage 2. Capital strategy grounded in real operating experience, not theory.",
    "capital.peter.bio1": "Former Head of Ecosystems and Partnerships for HSBC Asset Management's Venture Capital arm in Hong Kong, covering HealthTech, FinTech and ClimaTech. Founder of openlab, HSBC's fintech sandbox.",
    "capital.peter.bio2": "Fifteen years at Intel leading brand, marketing and Asia customer strategy, where he developed and launched multiple USD$100M+ products across the region.",
    "capital.peter.bio3": "Co-founder and Director of innovation accelerators in Hong Kong and Singapore — nine programmes, 75+ startups, USD$50M+ raised and climbing. Founding member of Mettā (Hong Kong) and active angel investor in FinTech, Media, Mobile and IoT.",
    "capital.peter.bio4": "The same operator instinct that built and funded those businesses now sits beside founders raising their own.",

    "capital.peter.stat1.label": "OPERATING",
    "capital.peter.stat1.value": "20+ Years",
    "capital.peter.stat1.detail": "Intel · HSBC · Nest · DBS · OCBC",
    "capital.peter.stat2.label": "ACCELERATORS",
    "capital.peter.stat2.value": "9 Programmes",
    "capital.peter.stat2.detail": "75+ startups · USD$50M+ raised",
    "capital.peter.stat3.label": "REACH",
    "capital.peter.stat3.value": "18 APAC Markets",
    "capital.peter.stat3.detail": "Multi-100M+ products launched at Intel",

    "capital.peter.credentials.label": "CREDENTIALS",
    "capital.peter.credentials.title": "Track Record",
    "capital.peter.credentials.item1": "Head of Ecosystems & Partnerships, HSBC Asset Management Venture Capital (Hong Kong) — HealthTech, FinTech, ClimaTech.",
    "capital.peter.credentials.item2": "15 years at Intel managing brand, marketing and Asia customer strategy. Developed and launched multiple USD$100M+ products across the region.",
    "capital.peter.credentials.item3": "Co-founder of innovation accelerators in HK and Singapore — 9 programmes, 75+ startups, USD$50M+ raised.",
    "capital.peter.credentials.item4": "Founding member of Mettā (HK). Angel investor across FinTech, Media, Mobile and IoT.",
    "capital.peter.credentials.item5": "Adjunct Professor at Massey Business School (NZ); previously Adjunct at Hong Kong Polytechnic University.",
    "capital.peter.credentials.item6": "Published case study author, Harvard Business Review. Multiple award-winning campaigns and industry programmes.",

    "capital.peter.focus.label": "FOCUS",
    "capital.peter.focus.title": "Where Peter Adds Weight",
    "capital.peter.focus.item1": "Sharpening commercial narrative and investor positioning before capital conversations begin.",
    "capital.peter.focus.item2": "Pressure-testing business model, traction story and unit economics from an operator's lens.",
    "capital.peter.focus.item3": "Translating NZ and AU founders into language that lands with Asia-Pacific capital.",
    "capital.peter.focus.item4": "Coaching founders through the round itself — pacing, objections, term sheet trade-offs.",

    "capital.david.alt": "David Thomas, Asia-Pacific capital partner",
    "capital.david.name": "David Thomas",
    "capital.david.role": "Asia-Pacific Capital Partner · Based in Asia with a focus on HK/SE Asia/ Australia",
    "capital.david.linkedin": "LinkedIn",
    "capital.david.website": "davidthomas.asia",
    "capital.david.eyebrow": "Partnership",
    "capital.david.title": "In Partnership with David Thomas",
    "capital.david.intro": "Stage 2 is delivered in direct partnership with David Thomas, whose investor relationships across Asia-Pacific underpin the credibility and reach of this offering.",
    "capital.david.bio1": "David has spent more than two decades operating at the intersection of Asia-Pacific capital and Western businesses. Based between Hong Kong and Australia, he has built and led ventures across financial services, technology and cross-border investment, and advised founders and boards on capital strategy throughout the region.",
    "capital.david.bio2": "His network spans venture capital firms, family offices, and strategic investors across Hong Kong, Singapore, SE Asia, Australia and New Zealand. These are the relationships that anchor every introduction we make.",
    "capital.david.bio3": "Investor access in this region is not transactional. It is built on trust, track record, and direct relationships. That is what David brings to this partnership.",

    "capital.david.stat1.label": "REGION",
    "capital.david.stat1.value": "Asia-Pacific",
    "capital.david.stat1.detail": "Hong Kong · Singapore · SE Asia · Australia · NZ",
    "capital.david.stat2.label": "EXPERIENCE",
    "capital.david.stat2.value": "25+ Years",
    "capital.david.stat2.detail": "Cross-border capital and investor relations",
    "capital.david.stat3.label": "NETWORK",
    "capital.david.stat3.value": "Institutional & Private",
    "capital.david.stat3.detail": "VC, family offices, strategic capital",

    "capital.david.credentials.label": "CREDENTIALS",
    "capital.david.credentials.title": "Track Record",
    "capital.david.credentials.item1": "Founder and CEO of multiple cross-border ventures across financial services and technology in Asia-Pacific.",
    "capital.david.credentials.item2": "Long-standing advisor to founders and boards on capital strategy, market entry and partnership structuring across the region.",
    "capital.david.credentials.item3": "Active investor relationships with venture capital firms, family offices and strategic capital across HK, Singapore, SE Asia, Australia and NZ.",
    "capital.david.credentials.item4": "Frequent commentator and speaker on Asia-Pacific business, investment and cross-border opportunity.",

    "capital.david.focus.label": "FOCUS",
    "capital.david.focus.title": "Where David Adds Weight",
    "capital.david.focus.item1": "Positioning Western founders for credibility with Asia-Pacific investors.",
    "capital.david.focus.item2": "Direct introductions into curated investor relationships, not cold outreach.",
    "capital.david.focus.item3": "Structuring conversations across cultural and commercial contexts.",
    "capital.david.focus.item4": "Pressure-testing capital strategy against the realities of regional investor expectations.",

    "capital.positioning.eyebrow": "Positioning",
    "capital.positioning.title": "A Structured Approach to Capital",
    "capital.positioning.p1": "This is not a broker service.",
    "capital.positioning.p2": "We do not distribute pitch decks broadly or rely on volume outreach.",
    "capital.positioning.p3": "We work through a disciplined process of:",
    "capital.positioning.item1": "targeted investor selection",
    "capital.positioning.item2": "structured engagement",
    "capital.positioning.item3": "ongoing advisory support throughout the capital process",
    "capital.positioning.closing1": "The objective is not activity.",
    "capital.positioning.closing2": "The objective is outcome.",

    "capital.process.eyebrow": "Process",
    "capital.process.title": "How We Engage Investors",
    "capital.process.intro": "Our capital engagement follows a defined four-stage process:",
    "capital.process.step1.title": "Research",
    "capital.process.step1.body": "We build a targeted list of aligned investors, typically 60 to 80, across venture capital, angel networks, and alternative funding sources.",
    "capital.process.step2.title": "Target",
    "capital.process.step2.body": "We design a tailored outreach strategy based on investor type, geography, and relevance to your opportunity.",
    "capital.process.step3.title": "Engage",
    "capital.process.step3.body": "We manage outreach and support investor conversations, providing ongoing feedback and positioning guidance.",
    "capital.process.step4.title": "Convert",
    "capital.process.step4.body": "We progress discussions toward credible term sheets and support you in evaluating and selecting the right capital partners.",

    "capital.advantage.eyebrow": "APAC Advantage",
    "capital.advantage.title": "Asia-Pacific Capital Access",
    "capital.advantage.intro": "Our investor networks extend across:",
    "capital.advantage.region1": "Hong Kong",
    "capital.advantage.region2": "Singapore",
    "capital.advantage.region3": "SE Asia",
    "capital.advantage.region4": "Australia",
    "capital.advantage.region5": "New Zealand",
    "capital.advantage.p1": "For the right companies, Asia is not a complexity risk.",
    "capital.advantage.p2": "It is a strategic capital advantage.",
    "capital.advantage.p3": "We help position it as such.",

    "capital.discipline.eyebrow": "Investor Discipline",
    "capital.discipline.title": "Quality Over Volume",
    "capital.discipline.p1": "We do not approach investors indiscriminately.",
    "capital.discipline.p2": "Each engagement is structured around:",
    "capital.discipline.item1": "relevance",
    "capital.discipline.item2": "alignment",
    "capital.discipline.item3": "credibility",
    "capital.discipline.note": "The objective is to create meaningful conversations with the right investors, not exposure to as many as possible.",

    "capital.commercial.eyebrow": "Commercial Alignment",
    "capital.commercial.title": "Aligned with Outcomes",
    "capital.commercial.p1": "Our involvement in capital raising is structured to align with results.",
    "capital.commercial.p2": "Engagements typically include:",
    "capital.commercial.item1": "A defined investor target list",
    "capital.commercial.item2": "Structured outreach and engagement support",
    "capital.commercial.item3": "Success-based participation upon capital raised",
    "capital.commercial.note": "Specific terms are agreed as part of each engagement.",

    "capital.expectation.eyebrow": "Founder Expectation",
    "capital.expectation.title": "What This Requires",
    "capital.expectation.p1": "This stage requires founders to operate at investor level.",
    "capital.expectation.p2": "That includes:",
    "capital.expectation.item1": "Clarity in communication",
    "capital.expectation.item2": "Responsiveness in engagement",
    "capital.expectation.item3": "Discipline in process",
    "capital.expectation.item4": "Willingness to adapt positioning based on feedback",
    "capital.expectation.note1": "We provide the structure and support.",
    "capital.expectation.note2": "Execution remains a shared responsibility.",

    "capital.cta.title": "Begin with Founder Readiness",
    "capital.cta.p1": "Capital engagement starts with clarity.",
    "capital.cta.p2": "Stage 2 is only available to companies that have completed Stage 1.",
    "capital.cta.button": "Start Founder Readiness",
    "capital.cta.tagline1": "The right narrative.",
    "capital.cta.tagline2": "The right investors.",
    "capital.cta.tagline3": "The right capital pathway across Asia-Pacific.",
    "capital.cta.book": "Or book a confidential call →",
  },
  zh: {
    "seo.capital.title": "资本募集 — 亚太地区投资人对接 | Peter Dingle",
    "seo.capital.description": "直接对接香港、新加坡、东南亚、澳大利亚和新西兰的匹配投资人。与 David Thomas 合作,以质取胜的融资流程。",

    "capital.hero.eyebrow": "第二阶段 · 资本募集 · 亚太地区",
    "capital.hero.title": "直接对接合适的亚太投资人,不做无谓的曝光。",
    "capital.hero.body": "如果你准备在香港、新加坡、东南亚、澳大利亚和新西兰募资,我们提供的是通过真正了解投资人的人建立的直接对接,而不是一份名单加一份群发的路演材料。",
    "capital.hero.tag1": "精选投资人对接",
    "capital.hero.tag2": "以质取胜,而非以量取胜",
    "capital.hero.tag3": "与结果挂钩的费用安排",
    "capital.hero.byline": "Peter Dingle(新西兰)· 与 David Thomas(香港/澳大利亚)合作",

    "capital.who.eyebrow": "适合谁",
    "capital.who.title": "适合已经准备好融资的创始人,而不是还在摸索方向的创始人。",
    "capital.who.item1": "已有收入或已完成试点,计划募资 100 万至 1000 万美元。",
    "capital.who.item2": "总部位于新西兰、澳大利亚或亚太地区,并有充分理由吸引亚太资本。",
    "capital.who.item3": "已完成第一阶段(创始人准备度评估),或已具备同等的投资就绪度。",
    "capital.who.item4": "希望与更少、更精准的投资人深入对话,而不是扩大漏斗。",

    "capital.why.eyebrow": "为什么选择我们",
    "capital.why.title": "两位实干者,真实的人脉关系,没有中介式的表演。",
    "capital.why.item1.name": "Peter Dingle",
    "capital.why.item1.rest": " —— 二十年间在 18 个亚太市场推动企业扩张。曾任职英特尔(主导多个超 1 亿美元产品的上市)、汇丰资产管理(香港生态系统与风险投资负责人),联合创立的加速器已为 75 家以上初创公司募得超 5000 万美元。",
    "capital.why.item2.name": "David Thomas",
    "capital.why.item2.rest": " —— 25 年以上活跃于亚太资本与西方企业之间。与该地区的风险投资机构、家族办公室及战略投资人保持直接联系。",
    "capital.why.item3": "每一次对接都通过你能核实的真实人脉完成,我们不会群发路演材料。",
    "capital.why.item4": "费用安排与结果挂钩,而非与工作量挂钩。",

    "capital.peter.alt": "Peter Dingle,创始人顾问及CEO导师",
    "capital.peter.name": "Peter Dingle",
    "capital.peter.role": "创始人顾问 · CEO 导师 · 常驻新西兰",
    "capital.peter.linkedin": "领英主页",
    "capital.peter.website": "petermdingle.com",
    "capital.peter.eyebrow": "关于 Peter",
    "capital.peter.title": "二十年站在亚太增长前沿的实战经历。",
    "capital.peter.intro": "Peter 带来了支撑第二阶段的创始人视角与商业业绩,他的资本策略建立在真实运营经验之上,而非纸上谈兵。",
    "capital.peter.bio1": "曾任汇丰资产管理旗下风险投资部门(香港)生态系统与合作伙伴关系负责人,覆盖健康科技、金融科技和气候科技领域。openlab(汇丰金融科技沙盒)的创始人。",
    "capital.peter.bio2": "在英特尔工作十五年,负责品牌、市场营销及亚洲客户战略,曾主导多个覆盖全区、销售额超 1 亿美元的产品上市。",
    "capital.peter.bio3": "在香港和新加坡联合创立并主导多个创新加速器项目 —— 九期项目,扶持超过 75 家初创公司,累计募资超 5000 万美元且仍在增长。Mettā(香港)创始成员,活跃于金融科技、媒体、移动互联网和物联网领域的天使投资人。",
    "capital.peter.bio4": "曾经用来打造和资助这些企业的实干本能,如今用在陪伴创始人完成自己的融资上。",

    "capital.peter.stat1.label": "从业经验",
    "capital.peter.stat1.value": "20 年以上",
    "capital.peter.stat1.detail": "英特尔 · 汇丰 · Nest · 星展银行 · 华侨银行",
    "capital.peter.stat2.label": "加速器项目",
    "capital.peter.stat2.value": "9 期项目",
    "capital.peter.stat2.detail": "75 家以上初创公司 · 募资超 5000 万美元",
    "capital.peter.stat3.label": "覆盖范围",
    "capital.peter.stat3.value": "18 个亚太市场",
    "capital.peter.stat3.detail": "在英特尔主导多个超 1 亿美元产品上市",

    "capital.peter.credentials.label": "履历",
    "capital.peter.credentials.title": "业绩记录",
    "capital.peter.credentials.item1": "汇丰资产管理风险投资部门(香港)生态系统与合作伙伴关系负责人 —— 覆盖健康科技、金融科技、气候科技。",
    "capital.peter.credentials.item2": "在英特尔工作 15 年,负责品牌、市场营销及亚洲客户战略,主导多个覆盖全区、销售额超 1 亿美元的产品上市。",
    "capital.peter.credentials.item3": "在香港和新加坡联合创立创新加速器 —— 9 期项目,75 家以上初创公司,募资超 5000 万美元。",
    "capital.peter.credentials.item4": "Mettā(香港)创始成员。活跃于金融科技、媒体、移动互联网和物联网领域的天使投资人。",
    "capital.peter.credentials.item5": "新西兰梅西商学院兼职教授;此前曾任香港理工大学兼职教授。",
    "capital.peter.credentials.item6": "《哈佛商业评论》案例研究作者,主导多个获奖的营销活动及行业项目。",

    "capital.peter.focus.label": "关注重点",
    "capital.peter.focus.title": "Peter 能带来的价值",
    "capital.peter.focus.item1": "在资本对话开始前,打磨商业叙事与投资人定位。",
    "capital.peter.focus.item2": "以实战运营者的视角,对商业模式、增长故事和单位经济模型进行压力测试。",
    "capital.peter.focus.item3": "帮助新西兰和澳大利亚创始人,将叙事转化为能打动亚太资本的语言。",
    "capital.peter.focus.item4": "在融资过程中给予创始人具体指导 —— 节奏把控、异议应对、条款取舍。",

    "capital.david.alt": "David Thomas,亚太资本合作伙伴",
    "capital.david.name": "David Thomas",
    "capital.david.role": "亚太资本合作伙伴 · 常驻亚洲,聚焦香港/东南亚/澳大利亚",
    "capital.david.linkedin": "领英主页",
    "capital.david.website": "davidthomas.asia",
    "capital.david.eyebrow": "合作伙伴",
    "capital.david.title": "与 David Thomas 携手合作",
    "capital.david.intro": "第二阶段由我们与 David Thomas 直接合作提供,他在亚太地区的投资人人脉是这项服务可信度和覆盖面的重要支撑。",
    "capital.david.bio1": "David 二十多年来一直活跃在亚太资本与西方企业的交汇点上。常驻香港与澳大利亚之间,曾创立并领导多家跨越金融服务、科技和跨境投资领域的企业,并为该地区的创始人和董事会提供资本战略建议。",
    "capital.david.bio2": "他的人脉网络覆盖香港、新加坡、东南亚、澳大利亚和新西兰的风险投资机构、家族办公室和战略投资人。这些正是支撑我们每一次对接的核心关系。",
    "capital.david.bio3": "在这个地区,投资人的接触机会不是靠交易换来的,而是建立在信任、业绩和直接关系之上。这正是 David 为这次合作带来的价值。",

    "capital.david.stat1.label": "覆盖区域",
    "capital.david.stat1.value": "亚太地区",
    "capital.david.stat1.detail": "香港 · 新加坡 · 东南亚 · 澳大利亚 · 新西兰",
    "capital.david.stat2.label": "从业经验",
    "capital.david.stat2.value": "25 年以上",
    "capital.david.stat2.detail": "跨境资本与投资人关系",
    "capital.david.stat3.label": "人脉网络",
    "capital.david.stat3.value": "机构与私人投资者",
    "capital.david.stat3.detail": "风险投资机构、家族办公室、战略资本",

    "capital.david.credentials.label": "履历",
    "capital.david.credentials.title": "业绩记录",
    "capital.david.credentials.item1": "在亚太地区创立并领导多家跨越金融服务与科技领域的跨境企业,担任创始人及CEO。",
    "capital.david.credentials.item2": "长期为该地区的创始人和董事会提供资本战略、市场进入及合作架构方面的建议。",
    "capital.david.credentials.item3": "与香港、新加坡、东南亚、澳大利亚和新西兰的风险投资机构、家族办公室及战略资本保持活跃的投资人关系。",
    "capital.david.credentials.item4": "经常就亚太商业、投资及跨境机遇发表评论和演讲。",

    "capital.david.focus.label": "关注重点",
    "capital.david.focus.title": "David 能带来的价值",
    "capital.david.focus.item1": "帮助西方创始人建立起亚太投资人认可的可信度。",
    "capital.david.focus.item2": "直接引荐进入精选的投资人关系网络,而非陌生开发。",
    "capital.david.focus.item3": "在不同文化和商业背景下搭建有效对话结构。",
    "capital.david.focus.item4": "结合区域投资人的真实预期,对资本策略进行压力测试。",

    "capital.positioning.eyebrow": "定位",
    "capital.positioning.title": "一套结构化的资本对接方式",
    "capital.positioning.p1": "这不是一项中介服务。",
    "capital.positioning.p2": "我们不会广泛群发路演材料,也不依赖大规模陌生开发。",
    "capital.positioning.p3": "我们遵循一套严谨的流程:",
    "capital.positioning.item1": "精准筛选目标投资人",
    "capital.positioning.item2": "结构化的对接过程",
    "capital.positioning.item3": "贯穿整个融资过程的持续顾问支持",
    "capital.positioning.closing1": "我们追求的不是忙碌的表面工作,",
    "capital.positioning.closing2": "而是实实在在的结果。",

    "capital.process.eyebrow": "流程",
    "capital.process.title": "我们如何对接投资人",
    "capital.process.intro": "我们的资本对接遵循明确的四个阶段:",
    "capital.process.step1.title": "调研",
    "capital.process.step1.body": "我们建立一份精准的匹配投资人名单,通常涵盖 60 至 80 家,涉及风险投资、天使投资网络及其他另类融资渠道。",
    "capital.process.step2.title": "锁定",
    "capital.process.step2.body": "我们根据投资人类型、所在地区及与你的项目的匹配度,制定专属的对接策略。",
    "capital.process.step3.title": "沟通",
    "capital.process.step3.body": "我们负责推进对接并支持与投资人的沟通,持续提供反馈及定位建议。",
    "capital.process.step4.title": "促成",
    "capital.process.step4.body": "我们推动对话走向可信的投资条款清单,并协助你评估和选择合适的资本合作伙伴。",

    "capital.advantage.eyebrow": "亚太优势",
    "capital.advantage.title": "亚太资本对接渠道",
    "capital.advantage.intro": "我们的投资人网络覆盖以下地区:",
    "capital.advantage.region1": "香港",
    "capital.advantage.region2": "新加坡",
    "capital.advantage.region3": "东南亚",
    "capital.advantage.region4": "澳大利亚",
    "capital.advantage.region5": "新西兰",
    "capital.advantage.p1": "对合适的企业而言,亚洲市场并不意味着更高的复杂性风险。",
    "capital.advantage.p2": "它是一项战略性的资本优势。",
    "capital.advantage.p3": "我们帮助你把这一点讲清楚、用起来。",

    "capital.discipline.eyebrow": "投资人筛选纪律",
    "capital.discipline.title": "以质取胜,而非以量取胜",
    "capital.discipline.p1": "我们不会不加筛选地接触投资人。",
    "capital.discipline.p2": "每一次对接都围绕以下三点展开:",
    "capital.discipline.item1": "相关性",
    "capital.discipline.item2": "契合度",
    "capital.discipline.item3": "可信度",
    "capital.discipline.note": "我们的目标是与合适的投资人展开有意义的对话,而不是尽可能多地曝光。",

    "capital.commercial.eyebrow": "费用安排",
    "capital.commercial.title": "与结果挂钩",
    "capital.commercial.p1": "我们参与资本募集的方式,设计上就是与结果挂钩的。",
    "capital.commercial.p2": "合作通常包括:",
    "capital.commercial.item1": "一份明确的目标投资人名单",
    "capital.commercial.item2": "结构化的对接与沟通支持",
    "capital.commercial.item3": "根据实际募资结果计费的成功参与机制",
    "capital.commercial.note": "具体条款将在每次合作中另行商定。",

    "capital.expectation.eyebrow": "对创始人的要求",
    "capital.expectation.title": "这一阶段需要你做到",
    "capital.expectation.p1": "这一阶段要求创始人以投资人的标准来要求自己。",
    "capital.expectation.p2": "具体包括:",
    "capital.expectation.item1": "沟通清晰",
    "capital.expectation.item2": "回应及时",
    "capital.expectation.item3": "流程严谨",
    "capital.expectation.item4": "愿意根据反馈调整定位",
    "capital.expectation.note1": "我们提供整体结构与支持,",
    "capital.expectation.note2": "而执行始终是双方共同承担的责任。",

    "capital.cta.title": "从创始人准备度评估开始",
    "capital.cta.p1": "资本对接始于清晰的认知。",
    "capital.cta.p2": "第二阶段仅面向已完成第一阶段的企业开放。",
    "capital.cta.button": "开始创始人准备度评估",
    "capital.cta.tagline1": "合适的叙事。",
    "capital.cta.tagline2": "合适的投资人。",
    "capital.cta.tagline3": "贯穿亚太地区的合适资本路径。",
    "capital.cta.book": "或预约一次保密沟通 →",
  },
} as const;
